import "./Homepage.css";

import HeroSection from "./HeroSection";
import AwakenSection from "./AwakenSection";
import Footer from "../../../global/footer/Footer";
import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ScrollTop from "../../../components/ScrollTop";

gsap.registerPlugin(ScrollTrigger);

export default function Homepage() {
  const ref = useRef();
  const splineObjectRef = useRef(null);
  const [isSplineReady, setIsSplineReady] = useState(false);

  const mobile = window.matchMedia("(max-width: 767px)").matches;

  const handleSplineReady = (object) => {
    splineObjectRef.current = object;

    setIsSplineReady(true);
  };

  return (
    <>
      <div className="anim-wrapper" ref={ref}>
        <HeroSection />
        <AwakenSection
          splineReg={splineObjectRef}
          onSplineReady={handleSplineReady}
        />
      </div>
      <ScrollTop />
      <Footer />
    </>
  );
}
